// Decisiones del técnico sobre los hallazgos de visitas anteriores (arrastre).
//
// El estado vive en el provider como un mapa por id del hallazgo previo:
//   decisionesPrevios = { [idHallazgoPrevio]: 'RESUELTO' | 'SIGUE' }
//
// Los dos destinos viajan al backend por caminos distintos, a propósito:
// - RESUELTO → `resolucionesHallazgos` del PUT (cierra el hallazgo).
// - SIGUE    → NO viaja acá: la incidencia arrastrada del ítem lleva
//              `idHallazgoPrevio` y el backend la crea como el eslabón siguiente.
//              Si viajara por los dos lados, se duplicaría el hallazgo.
export const DECISION = {
  RESUELTO: 'RESUELTO',
  SIGUE: 'SIGUE',
};

export function buildResolucionesPayload(decisiones) {
  if (!decisiones) return [];
  return Object.entries(decisiones)
    .filter(([, accion]) => accion === DECISION.RESUELTO)
    .map(([idHallazgo]) => ({ idHallazgo: Number(idHallazgo), accion: DECISION.RESUELTO }));
}

// IDs de hallazgos previos cuya decisión (RESUELTO o SIGUE) el técnico deshizo
// después de haberla tomado — por "Deshacer", por reclasificar el ítem
// (limpiarArrastresDelItem) o por cambiar de decisión sin pasar por
// "Deshacer" (decidirPrevio). Viaja en el PUT como `resolucionesEliminadas`:
// el backend borra la entrada del ledger y reabre el hallazgo previo. Es
// idempotente del lado del backend (mandar un id sin decisión guardada es
// no-op), así que acá no distinguimos si la decisión llegó a persistirse:
// registramos TODA reversión y la reenviamos siempre — es la forma más simple
// y robusta de no perder una reversión real.
export function buildResolucionesEliminadasPayload(decisionesEliminadas) {
  if (!Array.isArray(decisionesEliminadas) || decisionesEliminadas.length === 0) return [];
  return decisionesEliminadas.map((id) => Number(id));
}
